var CompareListModel = require('./hpe.catalog.comparelist.model');

/**
 * product catalog compare tray controller
 */
module.exports = (function() {

    /**
     * initialization called by hpe.core.catalog.js
     */
    function initialize() {

        var element = document.querySelector('.hpe-catalog-template');

        if (element) {

            this.model = new CompareListModel({
                path: element.getAttribute('data-path'),
                comparePath: element.getAttribute('data-compare-path')
            });
        }
    }

    /**
     * public methods
     */
    return {
        initialize: initialize
    };

})();
